<div class="field-card" [class.selected]="isSelected" [class.expanded]="isExpanded">
	<div class="field-card-header" (click)="onFieldClick()">
		<button
			mat-icon-button
			class="expand-button"
			*ngIf="fieldType !== 'Script'"
			(click)="toggleExpand($event)"
			[matTooltip]="isExpanded ? 'Collapse properties' : 'Expand to edit properties'"
		>
			<mat-icon>{{ isExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
		</button>
		<mat-icon class="field-icon" [matTooltip]="fieldType + ' field'">{{ fieldIcon }}</mat-icon>
		<div class="field-info">
			<div class="field-label">
				{{ fieldLabel }}
				<mat-icon class="required-indicator" *ngIf="isRequired" matTooltip="Required field">star</mat-icon>
			</div>
			<div class="field-meta">
				<span class="field-type" matTooltip="Field type">{{ fieldType }}</span>
				<span class="field-key" *ngIf="fieldKey !== 'No Key'" matTooltip="Field key for model binding">{{
					fieldKey
				}}</span>
				<span class="api-badge" *ngIf="hasApi" [matTooltip]="apiTooltip">
					<mat-icon>http</mat-icon>
					API
				</span>
				<span class="dependency-badge" *ngIf="hasDependencies" [matTooltip]="dependencyTooltip">
					<mat-icon>device_hub</mat-icon>
					DEPS
				</span>
			</div>
		</div>
		<div class="field-actions" *ngIf="fieldType !== 'Script'">
			<button mat-icon-button class="action-button" (click)="onMoveUp($event)" matTooltip="Move Up">
				<mat-icon>arrow_upward</mat-icon>
			</button>
			<button mat-icon-button class="action-button" (click)="onMoveDown($event)" matTooltip="Move Down">
				<mat-icon>arrow_downward</mat-icon>
			</button>
			<button mat-icon-button class="action-button" (click)="onDuplicate($event)" matTooltip="Duplicate">
				<mat-icon>content_copy</mat-icon>
			</button>
			<button mat-icon-button class="action-button delete-button" (click)="onDelete($event)" matTooltip="Delete">
				<mat-icon>delete</mat-icon>
			</button>
		</div>
	</div>

	<!-- Expandable Properties Section -->
	<div class="field-properties" *ngIf="isExpanded">
		<form [formGroup]="propertiesForm" (click)="$event.stopPropagation()">
			<!-- Basic Properties -->
			<div class="properties-section">
				<h4 class="section-title">
					<mat-icon>info</mat-icon>
					Basic Properties
				</h4>
				<div class="form-row">
					<mat-form-field appearance="outline" class="form-field">
						<mat-label>Key</mat-label>
						<input matInput formControlName="key" placeholder="fieldKey" />
						<mat-hint>Unique identifier</mat-hint>
					</mat-form-field>
					<mat-form-field appearance="outline" class="form-field">
						<mat-label>Label</mat-label>
						<input matInput formControlName="label" placeholder="Enter label" />
					</mat-form-field>
				</div>
				<mat-form-field appearance="outline" class="form-field formly-full-width">
					<mat-label>Placeholder</mat-label>
					<input matInput formControlName="placeholder" placeholder="Enter placeholder" />
				</mat-form-field>
				<mat-form-field appearance="outline" class="form-field formly-full-width">
					<mat-label>Description</mat-label>
					<textarea
						matInput
						formControlName="description"
						rows="2"
						placeholder="Enter description"
					></textarea>
				</mat-form-field>
				<mat-form-field appearance="outline" class="form-field formly-full-width" *ngIf="showInputTypeField">
					<mat-label>Input Type</mat-label>
					<mat-select formControlName="inputType">
						<mat-option value="text">Text</mat-option>
						<mat-option value="email">Email</mat-option>
						<mat-option value="tel">Telephone</mat-option>
						<mat-option value="number">Number</mat-option>
						<mat-option value="password">Password</mat-option>
						<mat-option value="url">URL</mat-option>
					</mat-select>
				</mat-form-field>
			</div>

			<!-- Validation -->
			<div class="properties-section">
				<h4 class="section-title">
					<mat-icon>check_circle</mat-icon>
					Validation
				</h4>
				<div class="checkbox-group">
					<mat-checkbox formControlName="required">Required</mat-checkbox>
					<mat-checkbox formControlName="disabled">Disabled</mat-checkbox>
					<mat-checkbox formControlName="exclude">Exclude from submission</mat-checkbox>
				</div>
			</div>

			<!-- Styling -->
			<div class="properties-section">
				<h4 class="section-title">
					<mat-icon>palette</mat-icon>
					Styling
				</h4>
				<mat-form-field appearance="outline" class="form-field formly-full-width">
					<mat-label>CSS Classes</mat-label>
					<input matInput formControlName="className" placeholder="class-name another-class" />
					<mat-hint>Space-separated CSS classes</mat-hint>
				</mat-form-field>

				<div class="style-grid">
					<mat-form-field appearance="outline" class="form-field">
						<mat-label>Width</mat-label>
						<input matInput formControlName="styleWidth" placeholder="100%, 300px, auto" />
					</mat-form-field>
					<mat-form-field appearance="outline" class="form-field">
						<mat-label>Background Color</mat-label>
						<input matInput type="color" formControlName="styleBackgroundColor" />
					</mat-form-field>
				</div>

				<div class="style-grid">
					<mat-form-field appearance="outline" class="form-field">
						<mat-label>Text Color</mat-label>
						<input matInput type="color" formControlName="styleColor" />
					</mat-form-field>
					<mat-form-field appearance="outline" class="form-field">
						<mat-label>Font Size</mat-label>
						<input matInput formControlName="styleFontSize" placeholder="14px, 1rem" />
					</mat-form-field>
				</div>

				<div class="style-grid">
					<mat-form-field appearance="outline" class="form-field">
						<mat-label>Padding</mat-label>
						<input matInput formControlName="stylePadding" placeholder="10px, 1rem 2rem" />
					</mat-form-field>
					<mat-form-field appearance="outline" class="form-field">
						<mat-label>Margin</mat-label>
						<input matInput formControlName="styleMargin" placeholder="10px, 1rem 2rem" />
					</mat-form-field>
				</div>

				<mat-form-field appearance="outline" class="form-field formly-full-width">
					<mat-label>Border</mat-label>
					<input matInput formControlName="styleBorder" placeholder="1px solid #ccc" />
				</mat-form-field>

				<mat-form-field appearance="outline" class="form-field formly-full-width">
					<mat-label>Custom Styles (Advanced)</mat-label>
					<textarea
						matInput
						formControlName="customStyles"
						rows="3"
						placeholder="border-radius: 8px;&#10;box-shadow: 0 2px 4px rgba(0,0,0,0.1);"
					></textarea>
					<mat-hint>CSS properties (one per line or semicolon-separated)</mat-hint>
				</mat-form-field>
			</div>

			<!-- API Configuration -->
			<div class="properties-section">
				<h4 class="section-title">
					<mat-icon>http</mat-icon>
					API Configuration
				</h4>
				<div class="api-url-row">
					<mat-form-field appearance="outline" class="form-field flex-grow">
						<mat-label>API Endpoint URL</mat-label>
						<input matInput formControlName="apiUrl" placeholder="/api/contract/GetStates" />
					</mat-form-field>
					<button
						mat-raised-button
						color="primary"
						class="test-button"
						(click)="testApiEndpoint($event)"
						[disabled]="apiTesting || !propertiesForm.get('apiUrl')?.value"
					>
						<mat-icon *ngIf="!apiTesting">play_arrow</mat-icon>
						<mat-spinner *ngIf="apiTesting" diameter="20"></mat-spinner>
						{{ apiTesting ? 'Testing...' : 'Test' }}
					</button>
				</div>

				<!-- API Test Results -->
				<div class="api-test-results" *ngIf="showApiTestResults">
					<div class="test-results-header">
						<mat-icon>{{ apiTestError ? 'error' : 'check_circle' }}</mat-icon>
						<span>Test Results</span>
						<button mat-icon-button (click)="closeApiTestResults($event)">
							<mat-icon>close</mat-icon>
						</button>
					</div>
					<div class="test-error" *ngIf="apiTestError">
						<mat-icon>warning</mat-icon>
						<span>{{ apiTestError }}</span>
					</div>
					<div class="test-success" *ngIf="apiTestResult && !apiTestError">
						<mat-icon>check_circle</mat-icon>
						<span>API returned {{ apiTestResultCount }} item(s)</span>
						<pre class="json-preview">{{ apiTestResultJson }}</pre>
					</div>
				</div>

				<div class="form-row">
					<mat-form-field appearance="outline" class="form-field">
						<mat-label>Label Field</mat-label>
						<input matInput formControlName="apiItemFieldLabel" placeholder="label" />
					</mat-form-field>
					<mat-form-field appearance="outline" class="form-field">
						<mat-label>Value Field</mat-label>
						<input matInput formControlName="apiItemFieldValue" placeholder="value" />
					</mat-form-field>
				</div>
			</div>

			<!-- Advanced Properties -->
			<div class="properties-section">
				<h4 class="section-title">
					<mat-icon>code</mat-icon>
					Advanced
				</h4>

				<!-- Expression Builder Toggle -->
				<div class="expression-mode-toggle">
					<mat-button-toggle-group value="{{ showExpressionBuilder ? 'builder' : 'raw' }}">
						<mat-button-toggle value="builder" (click)="useExpressionBuilder()">
							<mat-icon>build</mat-icon>
							Visual Builder
						</mat-button-toggle>
						<mat-button-toggle value="raw" (click)="useRawExpression()">
							<mat-icon>code</mat-icon>
							Raw Expression
						</mat-button-toggle>
					</mat-button-toggle-group>
				</div>

				<!-- Visual Expression Builder -->
				<div class="expression-builder" *ngIf="showExpressionBuilder">
					<div class="builder-info">
						<mat-icon>info</mat-icon>
						<span>Hide this field when these conditions are met:</span>
					</div>

					<div class="condition-list">
						<div class="condition-row" *ngFor="let condition of expressionConditions; let i = index">
							<!-- Logic Selector (AND/OR) for non-first conditions -->
							<div class="logic-selector" *ngIf="i > 0">
								<mat-button-toggle-group
									[(ngModel)]="condition.logic"
									[ngModelOptions]="{ standalone: true }"
									(change)="buildExpressionFromConditions()"
								>
									<mat-button-toggle value="AND">AND</mat-button-toggle>
									<mat-button-toggle value="OR">OR</mat-button-toggle>
								</mat-button-toggle-group>
							</div>

							<!-- Condition Inputs -->
							<div class="condition-inputs">
								<mat-form-field appearance="outline" class="condition-field">
									<mat-label>Field</mat-label>
									<mat-select
										[(ngModel)]="condition.field"
										[ngModelOptions]="{ standalone: true }"
										(ngModelChange)="buildExpressionFromConditions()"
									>
										<mat-option *ngFor="let fieldKey of availableFields" [value]="fieldKey">{{
											fieldKey
										}}</mat-option>
									</mat-select>
									<mat-hint>Choose field to check</mat-hint>
								</mat-form-field>

								<mat-form-field appearance="outline" class="condition-operator">
									<mat-label>Operator</mat-label>
									<mat-select
										[(ngModel)]="condition.operator"
										[ngModelOptions]="{ standalone: true }"
										(ngModelChange)="buildExpressionFromConditions()"
									>
										<mat-option *ngFor="let op of operators" [value]="op.value">{{
											op.label
										}}</mat-option>
									</mat-select>
								</mat-form-field>

								<mat-form-field
									appearance="outline"
									class="condition-value"
									*ngIf="condition.operator !== 'truthy' && condition.operator !== 'falsy'"
								>
									<mat-label>Value</mat-label>
									<input
										matInput
										[(ngModel)]="condition.value"
										[ngModelOptions]="{ standalone: true }"
										(ngModelChange)="buildExpressionFromConditions()"
										placeholder="value"
									/>
								</mat-form-field>

								<button
									mat-icon-button
									color="warn"
									(click)="removeCondition(i)"
									matTooltip="Remove condition"
								>
									<mat-icon>delete</mat-icon>
								</button>
							</div>
						</div>
					</div>

					<button mat-stroked-button (click)="addCondition()" class="add-condition-button">
						<mat-icon>add</mat-icon>
						Add Condition
					</button>
				</div>

				<!-- Raw Expression Input -->
				<mat-form-field
					appearance="outline"
					class="form-field formly-full-width"
					*ngIf="!showExpressionBuilder"
				>
					<mat-label>Hide Expression</mat-label>
					<textarea
						matInput
						formControlName="hideExpression"
						rows="3"
						placeholder="e.g., !model.showField || model.status === 'inactive'"
					></textarea>
					<mat-hint>JavaScript expression using model.fieldName</mat-hint>
				</mat-form-field>

				<div class="dependency-info" *ngIf="referencedFields.length > 0">
					<mat-icon>device_hub</mat-icon>
					<span>Depends on: </span>
					<mat-chip-listbox>
						<mat-chip-option *ngFor="let field of referencedFields" disabled>{{ field }}</mat-chip-option>
					</mat-chip-listbox>
				</div>
			</div>

			<!-- Nested Scripts Configuration -->
			<div class="properties-section" *ngIf="isNestedScript">
				<h4 class="section-title">
					<mat-icon>list_alt</mat-icon>
					Nested Scripts
					<span *ngIf="selectedScripts.length > 0" class="script-count-badge">{{
						selectedScripts.length
					}}</span>
				</h4>

				<!-- Selected Scripts -->
				<div class="selected-scripts-container">
					<div class="section-subtitle">
						<span>Selected Scripts ({{ selectedScripts.length }})</span>
						<mat-hint>Scripts will execute in order</mat-hint>
					</div>

					<div class="selected-scripts-list" *ngIf="selectedScripts.length > 0">
						<div class="script-item" *ngFor="let script of selectedScripts; let i = index">
							<div class="script-order">{{ i + 1 }}</div>
							<div class="script-info">
								<div class="script-name">{{ script.name }}</div>
								<div class="script-id">ID: {{ script.scriptId }}</div>
							</div>
							<div class="script-actions">
								<button
									mat-icon-button
									(click)="moveScriptUp(i, $event)"
									[disabled]="i === 0"
									matTooltip="Move up"
								>
									<mat-icon>arrow_upward</mat-icon>
								</button>
								<button
									mat-icon-button
									(click)="moveScriptDown(i, $event)"
									[disabled]="i === selectedScripts.length - 1"
									matTooltip="Move down"
								>
									<mat-icon>arrow_downward</mat-icon>
								</button>
								<button
									mat-icon-button
									color="warn"
									(click)="removeScript(i, $event)"
									matTooltip="Remove"
								>
									<mat-icon>delete</mat-icon>
								</button>
							</div>
						</div>
					</div>

					<div class="empty-state" *ngIf="selectedScripts.length === 0">
						<mat-icon>info</mat-icon>
						<p>No scripts selected</p>
					</div>
				</div>

				<!-- Available Scripts -->
				<div class="available-scripts-container">
					<mat-form-field appearance="outline" class="form-field formly-full-width">
						<mat-label>Search and add scripts</mat-label>
						<input
							matInput
							[(ngModel)]="scriptSearchTerm"
							[ngModelOptions]="{ standalone: true }"
							placeholder="Search by name or ID"
						/>
						<mat-icon matPrefix>search</mat-icon>
					</mat-form-field>

					<div class="loading-state" *ngIf="loadingScripts">
						<mat-spinner diameter="30"></mat-spinner>
					</div>

					<div class="available-scripts-list" *ngIf="!loadingScripts && filteredAvailableScripts.length > 0">
						<div
							class="script-item formly-clickable"
							*ngFor="let script of filteredAvailableScripts | slice: 0 : 10"
							(click)="addScript(script, $event)"
						>
							<div class="script-info">
								<div class="script-name">{{ script.name }}</div>
								<div class="script-id">ID: {{ script.scriptId }}</div>
							</div>
							<mat-icon color="primary">add_circle</mat-icon>
						</div>
						<div class="more-results" *ngIf="filteredAvailableScripts.length > 10">
							+ {{ filteredAvailableScripts.length - 10 }} more (refine search)
						</div>
					</div>

					<div
						class="empty-state"
						*ngIf="!loadingScripts && scriptSearchTerm && filteredAvailableScripts.length === 0"
					>
						<mat-icon>search_off</mat-icon>
						<p>No scripts found</p>
					</div>
				</div>
			</div>

			<!-- Action Buttons -->
			<div class="properties-actions">
				<button mat-raised-button color="primary" (click)="onApplyChanges($event)">
					<mat-icon>check</mat-icon>
					Save Changes
				</button>
				<button mat-stroked-button (click)="onCancelChanges($event)">
					<mat-icon>close</mat-icon>
					Cancel
				</button>
			</div>
		</form>
	</div>

	<!-- Nested Children Section for Groups, Repeaters, and Nested Scripts -->
	<div
		class="nested-children-section"
		[class.is-repeater]="isRepeater"
		[class.is-nested-script]="isNestedScript"
		[class.is-group]="isGroup"
		*ngIf="isGroup || isRepeater || (isNestedScript && hasChildren)"
	>
		<div class="children-header" (click)="toggleChildren($event)">
			<div class="toggle-button">
				<mat-icon>{{ isChildrenExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
			</div>
			<mat-icon class="section-icon">
				{{ isRepeater ? 'repeat' : isNestedScript ? 'list_alt' : 'view_agenda' }}
			</mat-icon>
			<span class="section-label">
				{{ isRepeater ? 'Repeatable Section' : isNestedScript ? 'Nested Scripts' : 'Group' }}
				<span class="count-badge" *ngIf="childCount > 0">{{ childCount }}</span>
			</span>
			<div class="expand-hint">Click to {{ isChildrenExpanded ? 'collapse' : 'expand' }}</div>
		</div>

		<div class="children-container" *ngIf="isChildrenExpanded">
			<!-- Add Field Section for Groups and Repeaters -->
			<div class="add-field-section" *ngIf="isGroup || isRepeater">
				<div class="add-field-header">
					<mat-icon>add_circle_outline</mat-icon>
					<span>Add Field to {{ isRepeater ? 'Repeater' : 'Group' }}</span>
				</div>
				<div class="field-type-grid">
					<button
						mat-stroked-button
						class="field-type-button"
						*ngFor="let fieldType of availableFieldTypes"
						(click)="addFieldToGroup(fieldType.type, $event)"
					>
						<mat-icon>{{ fieldType.icon }}</mat-icon>
						<span>{{ fieldType.label }}</span>
					</button>
				</div>
			</div>

			<div class="children-list" *ngIf="childFields.length > 0">
				<div class="child-wrapper" *ngFor="let childField of childFields; let i = index">
					<nx-ahs-field-card
						[field]="childField"
						[path]="getChildPath(i)"
						[allFields]="allFields"
						[isSelected]="false"
						(fieldSelected)="fieldSelected.emit($event)"
						(fieldUpdated)="onChildFieldUpdated(i, $event)"
						(deleteField)="onChildDeleted(i)"
						(duplicateField)="onChildDuplicated(i)"
						(moveUp)="onChildMoveUp(i)"
						(moveDown)="onChildMoveDown(i)"
					>
					</nx-ahs-field-card>
				</div>
			</div>

			<!-- Empty State for Groups/Repeaters -->
			<div class="empty-group-state" *ngIf="childFields.length === 0 && (isGroup || isRepeater)">
				<mat-icon>{{ isRepeater ? 'repeat' : 'view_agenda' }}</mat-icon>
				<p>No fields in this {{ isRepeater ? 'repeater' : 'group' }} yet</p>
				<span>Add fields using the buttons above</span>
			</div>
		</div>
	</div>

	<!-- Simple indicator for other nested fields -->
	<div
		class="field-children"
		*ngIf="hasChildren && !isGroup && !isRepeater && !isNestedScript"
		matTooltip="This field contains nested child fields"
	>
		<mat-icon class="children-indicator">subdirectory_arrow_right</mat-icon>
		<span class="children-text">Contains {{ childCount }} nested field(s)</span>
	</div>
</div>
